import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { memo, useCallback } from "react";
import ProductCard from "@/components/products/ProductCard";
import type { Product } from "@/interfaces/product";

type Props = {
  product: Product;
  onClick: (id: string) => void;
  isSelected: boolean;
  onToggleSelect: (id: string) => void;
  onRemove: (id: string) => void;
  position: number;
  isAddedFromLowerTier?: boolean;
};

function SortableProductCard({
  product,
  onClick,
  isSelected,
  onToggleSelect,
  onRemove,
  position,
  isAddedFromLowerTier,
}: Props) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: product.id,
  });

  const handleClick = useCallback(() => onClick(product.id), [onClick, product.id]);
  const handleToggle = useCallback(() => onToggleSelect(product.id), [onToggleSelect, product.id]);
  const handleRemove = useCallback(() => onRemove(product.id), [onRemove, product.id]);

  return (
    <div
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.4 : 1,
        zIndex: isDragging ? 999 : "auto",
        position: "relative",
        cursor: isDragging ? "grabbing" : "grab",
      }}
      {...attributes}
      {...listeners}
    >
      <ProductCard
        product={product}
        onClick={handleClick}
        isEditMode
        isSelected={isSelected}
        onToggleSelect={handleToggle}
        onRemove={handleRemove}
        position={position}
        isAddedFromLowerTier={isAddedFromLowerTier}
      />
    </div>
  );
}

export default memo(SortableProductCard);
